const navigationReducer = (state, action) => {
    if (state === undefined) {
        state = {
            title: "Clusters",
            drawerOpen: false
        };
        return state;
    }
    switch (action.type) {
        case "SET_PAGE_TITLE":
            return {
                ...state,
                title: action.title,
                drawerOpen: false, // pri zmene stranky zavriet drawer
            };
        case "OPEN_NAVIGATION":
            return {
                ...state,
                drawerOpen: true,
            };
        case "CLOSE_NAVIGATION":
            return {
                ...state,
                drawerOpen: false,
            };
        default:
            return state
    }
};
export default navigationReducer;
